"use strict";

module.exports = require("./FileInput.js");